import React, { useState } from 'react';
import PropTypes from 'prop-types';

const RatingInput = ({ value, onChange, maxRating = 5, className = '', size = 'text-3xl' }) => {
  const [hoverRating, setHoverRating] = useState(0);

  const handleMouseEnter = (starValue) => {
    setHoverRating(starValue);
  };

  const handleMouseLeave = () => {
    setHoverRating(0); // Reset hover state when mouse leaves the container
  };

  const handleClick = (starValue) => {
    onChange(starValue);
  };

  return (
    <div
      className={`flex items-center space-x-1 ${className}`}
      onMouseLeave={handleMouseLeave}
    >
      {[...Array(maxRating)].map((_, index) => {
        const starValue = index + 1;
        const isFilled = starValue <= (hoverRating || value);

        return (
          <button
            key={starValue}
            type="button" // Important for forms
            onClick={() => handleClick(starValue)}
            onMouseEnter={() => handleMouseEnter(starValue)}
            className={`
              ${size}
              transition-colors duration-150 ease-in-out
              ${isFilled ? 'text-yellow-500' : 'text-gray-300 hover:text-yellow-300'}
              focus:outline-none focus:ring-2 focus:ring-yellow-400 focus:ring-offset-2 rounded-sm
            `}
            aria-label={`Rate ${starValue} out of ${maxRating} stars`}
            aria-pressed={starValue === value}
          >
            ★
          </button>
        );
      })}
    </div>
  );
};

RatingInput.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  maxRating: PropTypes.number,
  className: PropTypes.string,
  size: PropTypes.string,
};

export default RatingInput;